var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomCaretArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37284 5.61785L0.765828 2.23406C-0.111551 1.41098 0.501227 0 1.7407 0H8.95474C10.1942 0 10.8208 1.41098 9.94348 2.23406L6.33649 5.61785C5.79335 6.12738 4.91599 6.12738 4.37284 5.61785Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCaretArrow);
export default __webpack_public_path__ + "static/media/custom-caret-arrow.8443b91f3357f84559b8d08b50084d78.svg";
export { ForwardRef as ReactComponent };